import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menuIndex: 0,
  },
  getters: {
    getMenuStatus: (state) => {
      return state.menuIndex;
    },
  },
  actions: {
    setMenuStatus(context, val) {
      context.state.menuIndex = val;
    },
  },
});
